export const GET_POSITIONS = `
  query getPositions($tenant_id: Int!, $filter: FilterPositionInput) {
    getPositions(tenant_id: $tenant_id, filter: $filter) {
      id
      name
      active
      vistage20_id
    }
  }
`;
